import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddLibraryForm from "./library-forms/add-library-form";
import { getLibraryPublications, updateLibraryPublicationStatus, deleteLibraryPublication } from "./libraryServices/libraryManagement";
import { useGlobalState } from "../../../services/hostelConst";
import AddLibraryPublicationForm from "./library-forms/add-publication-form";

const LibraryPublicationTable = () => {
  const { toggleHostelMenu } = useGlobalState();
  var { id } = useParams();
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();

  useEffect(() => {
    openModal({ ...modalState, libraryId: id });

    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {};
  }, []);

  return (
    <MasterTable
      getTableData={getLibraryPublications}
      tab1={"Library"}
      tab2={"Publications"}
      updateStatus={updateLibraryPublicationStatus}
      libraryId={id}
      AddForm={AddLibraryPublicationForm}
      deleteRow={deleteLibraryPublication}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default LibraryPublicationTable;
